import { checkauth } from '../Helper';

const SiteHealth = () => import('../views/sitehealth/Index.vue');
const SiteHealthPage = () => import('../views/sitehealth/Pagina.vue');

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

// Sito ecommerce → Salute del sito: l'ultima scansione, una scansione precisa (link della notifica) e il dettaglio di un URL
export default [
	{ path: '/ecommerce/site-health', name: 'sitehealth', component: SiteHealth, beforeEnter: guard },
	{ path: '/ecommerce/site-health/:id([0-9a-fA-F]{24})', name: 'sitehealth-crawl', component: SiteHealth, beforeEnter: guard },
	{ path: '/ecommerce/site-health/:id([0-9a-fA-F]{24})/pages/:pageId([0-9a-fA-F]{24})', name: 'sitehealth-page', component: SiteHealthPage, beforeEnter: guard },
	// controllo immediato di un solo indirizzo (?url=), senza scansione
	{ path: '/ecommerce/site-health/check', name: 'sitehealth-check', component: SiteHealthPage, beforeEnter: guard },
];
